const Tests = {
  common: [
    {
      test: "How Strong Are Your Defense Mechanisms?",
      link: "https://infiheal.com/personality-test/defense-mechanisms",
    },
    {
      test: "Jealousy Test: Triggers",
      link: "https://infiheal.com/personality-test/jealousy",
    },
    {
      test: "Environmental Factors Depression: Self-Understanding and Insights",
      link: "https://infiheal.com/personality-test/environmental-factors-depression",
    },
    {
      test: "FOMO Test",
      link: "https://infiheal.com/personality-test/fomo",
    },
    {
      test: "Highly Sensitive Person Test",
      link: "https://infiheal.com/personality-test/high-sensitive-person-test",
    },
    {
      test: "Social Media Use Test",
      link: "https://infiheal.com/personality-test/social",
    },
    {
      test: "Brain Rot Test: Endless Reels?",
      link: "https://infiheal.com/personality-test/brain-rot",
    },
    {
      test: "Child Family Dysfunction: Self-Understanding and Insights",
      link: "https://infiheal.com/personality-test/child-family-dysfunction",
    },
    {
      test: "Child Syndrome Test: Explore Childhood Behavioral Patterns",
      link: "https://infiheal.com/personality-test/child-syndrome",
    },
    {
      test: "Work Test: Stress & Motivation",
      link: "https://infiheal.com/personality-test/work",
    },
    {
      test: "Burnout Test: Exhaustion",
      link: "https://infiheal.com/personality-test/burnout",
    },
    {
      test: "Narcissist Relationship Test",
      link: "https://infiheal.com/personality-test/relationship-with-a-narcissist",
    },
    {
      test: "Toxic Partner Test",
      link: "https://infiheal.com/personality-test/is-your-partner-toxic",
    },
    {
      test: "Relationship Health Test",
      link: "https://infiheal.com/personality-test/is-your-relationship-healthy",
    },
    {
      test: "Am I the Fixer in Relationships?",
      link: "https://infiheal.com/personality-test/relationship-fixer",
    },
    {
      test: "Relationship Commitment Test",
      link: "https://infiheal.com/personality-test/relationship-commitment",
    },
    {
      test: "Dependent Personality Test",
      link: "https://infiheal.com/personality-test/dpd",
    },
    {
      test: "Codependency Test",
      link: "https://infiheal.com/personality-test/codependent-test",
    },
    {
      test: "Emotionally Unavailable Test",
      link: "https://infiheal.com/personality-test/emotionally-unavailable",
    },
    {
      test: "People Pleaser Test",
      link: "https://infiheal.com/personality-test/people-pleaser",
    },
    {
      test: "Caregiver Burnout Test",
      link: "https://infiheal.com/personality-test/caregiver",
    },
    {
      test: "Anger Style Test",
      link: "https://infiheal.com/personality-test/know-your-anger",
    },
    {
      test: "Rejection Sensitivity Test",
      link: "https://infiheal.com/personality-test/rejection-sensitive",
    },
    {
      test: "Eco-Anxiety Test",
      link: "https://infiheal.com/personality-test/eco-anxiety",
    },
    {
      test: "Erotic Sexual Test: Desire Style",
      link: "https://infiheal.com/personality-test/erotic-sexual-test",
    },
    {
      test: "Emotionally Unavailable Test",
      link: "https://infiheal.com/personality-test/emotionally-unavailable",
    },
    {
      test: "Ayurveda Test",
      link: "https://infiheal.com/personality-test/ayurveda",
    },
    {
      test: "Separation Anxiety Test",
      link: "https://infiheal.com/personality-test/separation-anxiety",
    },
    {
      test: "Generalized Anxiety Test",
      link: "https://infiheal.com/personality-test/generalized-anxiety",
    },
    {
      test: "Panic Disorder Test",
      link: "https://infiheal.com/personality-test/panic",
    },
    {
      test: "Core Fears: Self-Understanding and Insights",
      link: "https://infiheal.com/personality-test/core-fears",
    },
    {
      test: "Trauma Screening Test",
      link: "https://infiheal.com/personality-test/trauma-screenings",
    },
    {
      test: "Complex PTSD Test",
      link: "https://infiheal.com/personality-test/complex-ptsd",
    },
    {
      test: "Alcohol Test: Usage Patterns",
      link: "https://infiheal.com/personality-test/alcohol",
    },
    {
      test: "Drugs Use Test",
      link: "https://infiheal.com/personality-test/drugs",
    },
    {
      test: "Smoking Test",
      link: "https://infiheal.com/personality-test/smoking",
    },
    {
      test: "Overeating Test",
      link: "https://infiheal.com/personality-test/binge-eating",
    },
    {
      test: "Narcissism Test",
      link: "https://infiheal.com/personality-test/narcissism-test",
    },
    {
      test: "BDD by Proxy Test",
      link: "https://infiheal.com/personality-test/bdd-by-proxy",
    },
    {
      test: "Muscle Dysmorphia Test",
      link: "https://infiheal.com/personality-test/muscle-dysmorphia",
    },
    {
      test: "Mental Health Risk Test",
      link: "https://infiheal.com/personality-test/susceptibility-to-mental",
    },
    {
      test: "Body Dysmorphic Test",
      link: "https://infiheal.com/personality-test/body-dysmorphic-disorder",
    },
    {
      test: "Mind-Body Depression Test: Signals",
      link: "https://infiheal.com/personality-test/mind-body-depression",
    },
    {
      test: "ADHD Traits Test",
      link: "https://infiheal.com/personality-test/adhd",
    },
    {
      test: "Personality Insights Depression: Self-Understanding and Insights",
      link: "https://infiheal.com/personality-test/personality-insights-depression",
    },
    {
      test: "Environmental Factors Depression: Self-Understanding and Insights",
      link: "https://infiheal.com/personality-test/environmental-factors-depression",
    },
    {
      test: "Counseling: Self-Understanding and Insights",
      link: "https://infiheal.com/personality-test/counseling-partb",
    },
    {
      test: "Synesthesia Test",
      link: "https://infiheal.com/personality-test/synesthesia",
    },
    {
      test: "Sexual Orientation Test",
      link: "https://infiheal.com/personality-test/allosexual",
    },
    {
      test: "Dependent Personality Test",
      link: "https://infiheal.com/personality-test/dpd",
    },
    {
      test: "Codependency Test",
      link: "https://infiheal.com/personality-test/codependent-test",
    },
    {
      test: "Child Syndrome Test: Explore Childhood Behavioral Patterns",
      link: "https://infiheal.com/personality-test/child-syndrome",
    },
    {
      test: "Child Family Dysfunction: Self-Understanding and Insights",
      link: "https://infiheal.com/personality-test/child-family-dysfunction",
    },
    {
      test: "Porn Use Test",
      link: "https://infiheal.com/personality-test/adult-content-consumption",
    },
    {
      test: "Relationship Commitment Test",
      link: "https://infiheal.com/personality-test/relationship-commitment",
    },
    {
      test: "Relationship Health Test",
      link: "https://infiheal.com/personality-test/is-your-relationship-healthy",
    },
    {
      test: "Social Anxiety Test: Fear Patterns",
      link: "https://infiheal.com/personality-test/social-anxiety",
    },
    {
      test: "Know Your Executive Functioning Level",
      link: "https://infiheal.com/personality-test/executive-functioning",
    },
    {
      test: "Borderline Disorder Test: Emotions",
      link: "https://infiheal.com/personality-test/borderline-personality-disorder",
    },
    {
      test: "General Anxiety Disorder-7",
      link: "https://infiheal.com/personality-test/gad-7",
    },
    {
      test: "Patient Health Questionnaire-9",
      link: "https://infiheal.com/personality-test/phq-9",
    },
    {
      test: "Adult ADHD Self-Report Scale for DSM-5",
      link: "https://infiheal.com/personality-test/asrs-5",
    },
    { test: "Alcohol Use Disorders Identification Test",
      link: "https://infiheal.com/personality-test/audit",}
      ,{
       test: "Drug Abuse Screening Test",
      link: "https://infiheal.com/personality-test/dast-10"},
      {
        test: "PTSD Checklist for DSM-5",
      link: "https://infiheal.com/personality-test/pcl-5",
      },
      {
         test: "Kessler Psychological Distress Scale",
      link: "https://infiheal.com/personality-test/k-10",
      }
  ],
  chakra: [
    {
      test: "Root Chakra Test: Stability",
      link: "https://infiheal.com/personality-test/root-chakra",
    },
    {
      test: "Sacral Chakra Test",
      link: "https://infiheal.com/personality-test/sacral-chakra",
    },
    {
      test: "Solar Plexus Chakra Test",
      link: "https://infiheal.com/personality-test/solar-plexus-chakra",
    },
    {
      test: "Heart Chakra Test",
      link: "https://infiheal.com/personality-test/anahata-chakra",
    },
    {
      test: "Throat Chakra Test",
      link: "https://infiheal.com/personality-test/vishuddha-chakra",
    },
    {
      test: "Third Eye Chakra Test",
      link: "https://infiheal.com/personality-test/third-eye-chakra",
    },
    {
      test: "Crown Chakra Test",
      link: "https://infiheal.com/personality-test/crown-chakra",
    },
  ],
  adhd: [
    {
      test: "Adult ADHD Self-Report Scale for DSM-5",
      link: "https://infiheal.com/personality-test/asrs-5",
      order: ["Negative Screen", "Positive Screen"],
      colors: {
        "Negative Screen": "#3B82F6",
        "Positive Screen": "#22C55E",
      },
      map: {
        Minimal: "Negative Screen",
        Mild: "Negative Screen",
        Moderate: "Positive Screen",
        Severe: "Positive Screen",
      },
    },
    {
      test: "Alcohol Use Disorders Identification Test",
      link: "https://infiheal.com/personality-test/audit",
      order: ["Low Risk", "Hazardous"],
      colors: {
        "Low Risk": "#3B82F6",
        "Hazardous": "#F59E0B",
      },
      map: {
        Minimal: "Low Risk",
        Mild: "Low Risk",
        Moderate: "Hazardous",
        Severe: "Hazardous",
      },
    },
    {
      test: "Drug Abuse Screening Test",
      link: "https://infiheal.com/personality-test/dast-10",
      order: ["Low Severity", "Moderate Severity", "Substantial Severity", "Severe"],
      colors: {
        "Low Severity": "#3B82F6",
        "Moderate Severity": "#F59E0B",
        "Substantial Severity": "#F59E0B",
        "Severe": "#22C55E",
      },
      map: {
        Minimal: "Low Severity",
        Mild: "Moderate Severity",
        Moderate: "Substantial Severity",
        Severe: "Severe",
      },
    },
    {
      test: "PTSD Checklist for DSM-5",
      link: "https://infiheal.com/personality-test/pcl-5",
      order: ["Below Cutoff", "Subthreshold", "PTSD: Moderate","PTSD: Severe"],
      colors: {
        "Below Cutoff": "#3B82F6",
        "Subthreshold": "#F59E0B",
        "PTSD: Moderate": "#F59E0B",
        "PTSD: Severe": "#22C55E",
      },
      map: {
        Minimal: "Below Cutoff",
        Mild: "Subthreshold",
        Moderate: "PTSD: Moderate",
        Severe: "PTSD: Severe",
      },
    },
    {
      test: "Kessler Psychological Distress Scale",
      link: "https://infiheal.com/personality-test/k-10",
      order: ["Likely to Be Well", "Mild Distress", "Moderate Distress","Severe Distress"],
      colors: {
        "Likely to Be Well": "#3B82F6",
        "Mild Distress": "#F59E0B",
        "Moderate Distress": "#F59E0B",
        "Severe Distress": "#22C55E",
      },
      map: {
        Minimal: "Likely to Be Well",
        Mild: "Mild Distress",
        Moderate: "Moderate Distress",
        Severe: "Severe Distress",
      },
    },
  ],
  work: [
    {
      test: "Work Style Personality Test",
      link: "https://infiheal.com/personality-test/work-style",
    },
    // {
    //   test: "Sacral Chakra Test",
    //   link: "https://infiheal.com/personality-test/sacral-chakra",
    // },
    // {
    //   test: "Root Chakra Test: Stability",
    //   link: "https://infiheal.com/personality-test/root-chakra",
    // },
    // {
    //   test: "Sacral Chakra Test",
    //   link: "https://infiheal.com/personality-test/sacral-chakra",
    // },
  ],
};

export default Tests;
